import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
//   typography: {
//     fontSize: 24
//   },
//   palette: {
//     type: 'light',
//     default: {
//       main: '#eef',
//       light: '#f0f',
//       dark: '#888'
//     },
//     primary: {
//       light: '#fff',
//       main: '#00f',
//       color:'#000',
//       dark: '#1183ca'
//     },
//     secondary: {
//       light: '#f00',
//       main: '#f00',
//       dark: '#00f',
//       contrastText: '#f0f'
//     },
//     appBar: {
//       color: 'primary'
//     },
//     overrides: {
//       MuiFormLabel: {
//         root: {
//           color: '#ccf',
//           fontWeight: 300,
//           fontSize: 16
//         }
//       },
//       MuiInput: {
//         underline: {
//           '&:before': {
//             borderBottom: '#fff'
//           },
//           '&:hover:not($disabled):before': {
//             borderBottom: '#f00'
//           }
//         }
//       }, 
//       MuiButton: { // Name of the component ⚛️ / style sheet
//             label: { // Name of the rule
//                 color: '#0ff', // Some CSS
//             },
//         },
//     }
//   }
});

export default theme;
